<template lang="html">

<section class="list-view row-center">

    <div class="contenedor-listado" :style="styles.backgroundWhite" :showEncuesta="false" :hasFicha="false">
      <div class="scroll-container">
        
        <section class="contenedor-tabla" :style="styles.colorBasic">

          <div class="contenedor-opciones row-between">

            <h2 class="ficha-title" :style="styles.colorBasic">Listado de observaciones</h2>

            <p class="ficha-subtitle">Si desea aportar documentación o hacer observaciones, por ejemplo, con la hoja firmada de visitas realizadas a tutores en centros educativos, puede aportarla y consultarla aquí.​</p>

            <div class="row-end">

            </div>

          </div>

          <div class="contenedor-botones row-center" :style="styles.backgroundWhite" style="width: 100%; padding: 15px;">
            <a class="btn -xs" :style="styles.solidPrimary" @click="showPopupObservacionTutor = true">Añadir observación</a>
          </div>
          
          <template v-if="loading">
            <div class="loader" id="loader"></div>
            <p class="loader-text">CARGANDO...</p>
          </template>
          <div class="scroll-table" v-else>
            <div class="contenedor-tabla list-observaciones" :type="$route.name" v-if="!!dataSelected">
              <template v-if="dataSelected && dataSelected.length != 0">

                <v-client-table :data="dataSelected" :columns="columns" :options="options">
                  
                </v-client-table>
              </template>

              <template v-else>
                NO HAY OBSERVACIONES
              </template>

            </div>

          </div>

        </section>
        
      </div>
    </div>

    <popup-observacion-tutor v-if="showPopupObservacionTutor" @cerrar="showPopupObservacionTutor = false" 
                              @observacionAnnadida="cargarListado"></popup-observacion-tutor>

  </section>

</template>

<script lang="js">

 import { ClientTable, Event } from 'vue-tables-2';

 import Vue from 'vue';

 Vue.use(ClientTable);

 import {mapActions, mapGetters} from 'vuex';

 import router from '@/router';
 
 import popupObservacionTutor from '@/components/parts/popup-observacion-tutor';

 export default  {
  name: 'list-view-observaciones',
  data(){
    return {
      loading: false,
      showPopupObservacionTutor: false,
      dataSelected: [],
      columns: ["fechaAlta", "titulo", "contenido", "enlaceAdjunto"],
      options: {
          skin: 'table',
          highlightMatches: true,
          headings: {
            fechaAlta: "Fecha",
            titulo: "Título",
            contenido: "Contenido",
            enlaceAdjunto: "Adjunto"
          },
          templates: {
            enlaceAdjunto: function (h, row, index) {
              if(!!row.enlaceAdjunto){                
                return <p class="descargar"><a class="btn -xs btn-ver-adjunto" href={row.enlaceAdjunto} target="_blank">VER</a></p>
              } else {
                return ""
              }
            }
          },
          filterable: false,
          texts: {
            filter: "Buscar:",
            filterBy: 'Filtrar por {column}',
            count: '',
            records: 'Resultados',
            limit: "Por Página: ",
            page: "Págína:",
            noResults: "No se han encontrado resultados",
            filterPlaceholder: "Escribe para buscar",
          },
          customSorting: {
            fechaAlta: function (ascending) {
              return function (a, b) {

                var dateObjectA, dateObjectB;

                if (a.fechaAlta != null && a.fechaAlta != "") {
                  const [datePart, timePart] = a.fechaAlta.split(" ");
                  const [day, month, year] = datePart.split("/");
                  const [hours, minutes] = timePart.split(":");
                  const adjustedMonth = parseInt(month, 10) - 1;
                  dateObjectA = new Date(year, adjustedMonth, day, hours, minutes);
                }

                if (b.fechaAlta != null && b.fechaAlta != "") {
                  const [datePart, timePart] = b.fechaAlta.split(" ");
                  const [day, month, year] = datePart.split("/");
                  const [hours, minutes] = timePart.split(":");
                  const adjustedMonth = parseInt(month, 10) - 1;
                  dateObjectB = new Date(year, adjustedMonth, day, hours, minutes);
                }

                if (ascending)
                  return dateObjectA >= dateObjectB ? 1 : -1;

                return dateObjectA <= dateObjectB ? 1 : -1;
              }
            }
          },
          dateFormat: 'DD-MM-YY',
          perPage: 30,
          resizableColumns: true,
          perPageValues: [10, 20, 30, 50],
          columnsClasses: {},
          sortIcon: {
            is: 'glyphicon-sort',
            base: 'glyphicon',
            up: 'fa fa-angle-up',
            down: 'fa fa-angle-down'
          },
          rowClassCallback(row, $route) {
            let lastParam = window.location.pathname.split("/").pop();
            return (row.idPractica == lastParam) ? 'selected' : '';
          }
        }
      }
  },
  mounted() {
    this.cargarListado();
  },
  methods : {
    ...mapActions(['setMenu','dameObservacionesTutor']),
    cargarListado() {
      this.loading=true;
      this.dameObservacionesTutor().then(r => {
        this.loading=false;
        this.dataSelected = r;
      })
    }
  },
  components : {
    'popup-observacion-tutor': popupObservacionTutor
  },
  computed : {
    ...mapGetters({
      styles : 'getStyles',
      colors : 'basicColors'
    }),    
  },
  watch : {
    
  }
}
</script>

<style lang="scss">

  .list-view{
    width: 100%;
    height: 100%;
    -webkit-flex-wrap: nowrap;
    -moz-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    -o-flex-wrap: nowrap;
    flex-wrap: nowrap;
    max-height:100%;
    position: relative;
    
  }

  .contenedor-listado {
    width: 100% !important;
    height: 100% !important;
    display: inline-block !important;
    overflow: hidden !important;
    padding: 20px !important;
  }

  .contenedor-ficha{
    width: 100%;
    height: 100%;
    display: inline-block;
    max-width: 600px;
    min-width: 500px;
    overflow: hidden;
    padding: 10px;
    position: relative;
    
    &[full="true"]{
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 7;
      max-width: 100%;
      border-left: none!important;
    }


  } 

  .scroll-container{
    width: 100%;
    height: 100%;
    min-height: 100%;
    display: inline-block;
    overflow: hidden;
  }


  .contenedor-ficha .scroll-container{
    // overflow: hidden;
  }

  .settings{
    position: absolute;
    right: 5px;
    top: 0;
    height: 30px;
    width:100px;
    z-index: 5;
  }

  .settings a{
    width: 25px;
    height: 30px;
    display: inline-block;
    line-height: 30px;
  }

  .contenedor-vista-encuesta{
    width: 100%;
    height: 100%;
    max-width: 600px;
    min-width: 500px;
    overflow: hidden;
    position: relative;
    flex-grow: 2;
    &[full="true"]{
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 5;
      max-width: 100%;
      border-left: none!important;
    }
  }

  .tabla-responsive{
    display: none;
  }

  @media screen and (max-height: 900){
    .contenedor-listado{
      .tabla-responsive{
        display: inline-block;
        width: 100%;
      }
      .tabla-pc{
        display: none;
      } 
    }
  }

  @media screen and (max-width: 1400px){
    .contenedor-listado {
      &[showEncuesta=true]{
        display: none;
      }
    }

    .contenedor-ficha{
      max-width: 100%;
      &[showEncuesta=true]{
        border-left: none!important;
      }
    }

    .contenedor-vista-encuesta{
      max-width: 100%;
    }

  }

  @media screen and (max-width: 1200px){
    .contenedor-listado[hasFicha="true"]{
      .tabla-responsive{
        display: inline-block;
        width: 100%;
      }
      .tabla-pc{
        display: none;
      } 
    }
  }

  @media screen and (max-width: 1023px){
   .contenedor-listado {
    &[hasFicha=true]{
      display: none;
    }
  }

  .contenedor-listado{
      .tabla-responsive{
        display: inline-block;
        width: 100%;
      }
      .tabla-pc{
        display: none;
      } 
    }


  .contenedor-ficha[showEncuesta="true"]{
    display: none;
  }

  .settings .icon-ampliar{
    display: none;
  }
  .contenedor-ficha{
    border-left: none!important;
    min-width: 0;
  }
  .contenedor-vista-encuesta{
    min-width: 0;
    border-left: none!important;
  }

}

  @media screen and (max-width: 600px){
    .contenedor-listado{
      padding: 10px;
    }
  }

  .ficha-title {
    margin-top: 0;
    margin-bottom: 0;
    width: auto;
  }

  .ficha-subtitle {
    width:100%;
    text-align: left;
    margin: 10px 0px;
  }

  .toggle-todo {
    position: absolute;
    left: 10px;
    top: 47px;
    width: 15px;
    height: 15px;
    line-height: 15px;
    background: #d8d8d8;
    font-size: 12px;
    color: #4a4a4a;
  }

  .contenedor-tabla {
    width: 100%;
    min-height: 100%;
    display: inline-block;
  }

  .contenedor-opciones {
    width: 100%;
    // padding-bottom: 20px;
    position: relative;
  }

  .option-table {
    text-transform: uppercase;
    font-size: 9px;
    text-align: center;
    padding: 0 10px;
    position: relative;
  }

  .column {
    width: 30px;
    height: 30px;
    position: relative;
    margin-bottom: 10px;

    svg {
      width: 40px;
    }
  }

  .to-ficha {
    width: 10px;
    height: 20px;
    display: inline-block;
    font-size: 0;

    svg {
      width: 10px;
      height: 20px;
    }
  }


  .checkbox-cell {
    min-width: 55px;
  }

  .VueTables__table{
    width: 100% !important;
  }

  .btn-ver-adjunto{
    background: #1DAA6C;
    color: white;
  }

  .list-observaciones > .VueTables > .table-responsive{
    max-height: calc(100vh - 375px);
  }

</style>


// WEBPACK FOOTER //
// src/components/views/list-view-observaciones.vue